/**
 * Complementary products quick-add bypass
 *
 * Why: l'app IzyRent intercepte tous les submits de form[action="/cart/add"]
 * sur la page produit pour forcer la sélection d'une date de location.
 * Les produits complémentaires (cross-sell) ne sont PAS des locations
 * (ex: blocs de minutes), donc ne devraient pas déclencher cette validation.
 *
 * Stratégie : intercepter en phase capture (avant IzyRent), bloquer la
 * propagation, et POSTer manuellement à /cart/add.js. Le custom element
 * `is="product-form"` natif du thème peut aussi rater son hydration quand
 * le HTML est injecté async par <product-recommendations> + dupliqué par
 * Swiper en mode loop ; cette approche bypasse complètement ce risque.
 */
(function () {
  'use strict';

  /**
   * IzyRent monkey-patche window.fetch pour intercepter les /cart/add.js
   * et forcer la validation date de location. On contourne ça en récupérant
   * un fetch "propre" depuis un iframe caché — son window.fetch n'est pas
   * patché par les scripts du document parent.
   */
  function getCleanFetch() {
    if (window.__digitadCleanFetch) return window.__digitadCleanFetch;
    try {
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      document.documentElement.appendChild(iframe);
      var f = iframe.contentWindow.fetch.bind(iframe.contentWindow);
      window.__digitadCleanFetch = f;
      return f;
    } catch (e) {
      return window.fetch.bind(window);
    }
  }

  function isComplementary(form) {
    return !!(form && form.closest && form.closest('.complementary-products'));
  }

  function showLoading(form, on) {
    var spinner = form.querySelector('.loading__spinner');
    var btn = form.querySelector('button[type="submit"]');
    if (spinner) spinner.classList.toggle('hidden', !on);
    if (btn) btn.disabled = on;
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-count, .cart-count-bubble span, .cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.tagName === 'CART-COUNT') {
            el.setAttribute('aria-label', cart.item_count + ' articles');
          }
        });
      })
      .catch(function () {});
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!isComplementary(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    showLoading(form, true);

    // Envoie tous les champs du form (form_type, section-id, id, etc.)
    // pour mimer exactement la requête native Shopify.
    var formData = new FormData(form);

    getCleanFetch()('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { refreshCart(); })
      .catch(function (err) {
        console.error('Complementary quick-add failed. Full response:', err);
        try { console.error('JSON dump:', JSON.stringify(err, null, 2)); } catch (_) {}
        var msg = (err && (err.description || err.message)) || 'Impossible d’ajouter ce produit au panier.';
        alert(msg);
      })
      .finally(function () {
        showLoading(form, false);
      });
  }

  /**
   * IzyRent (ou bfcache navigateur) laisse parfois les boutons des cartes
   * complémentaires en disabled="disabled" — visible quand on navigue d'une
   * fiche produit à l'autre sans recharger. On force l'activation.
   */
  function enableComplementaryButtons() {
    document.querySelectorAll('.complementary-products button[disabled]').forEach(function (btn) {
      btn.removeAttribute('disabled');
      btn.disabled = false;
    });
  }

  document.addEventListener('DOMContentLoaded', enableComplementaryButtons);
  window.addEventListener('pageshow', enableComplementaryButtons); // bfcache restore
  if (document.readyState !== 'loading') enableComplementaryButtons();

  // Cards injectées async par <product-recommendations> ou dupliquées par Swiper
  if (window.MutationObserver) {
    new MutationObserver(function () {
      enableComplementaryButtons();
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Capture phase = on s'exécute avant les listeners non-capture d'IzyRent
  document.addEventListener('submit', handleSubmit, true);

  // Un click sur le bouton submit pourrait déclencher un listener IzyRent
  // avant le submit. On stoppe la propagation au capture aussi.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action="/cart/add"]');
    if (!isComplementary(form)) return;
    e.stopPropagation();
  }, true);
})();
